interface ProcessProps {
  scrollToContact: () => void;
}

export default function Process({ scrollToContact }: ProcessProps) {
  const steps = [
    {
      number: '1',
      icon: 'ri-clipboard-line',
      title: 'Free Inspection',
      description: 'We conduct a thorough roof inspection and document everything needed for your insurance claim at no cost to you.'
    },
    {
      number: '2',
      icon: 'ri-file-shield-line',
      title: 'Insurance Coordination',
      description: 'Our team communicates directly with your insurance company, handling all paperwork and claim filing on your behalf.'
    },
    {
      number: '3',
      icon: 'ri-calendar-check-line',
      title: 'Scheduled Installation',
      description: 'Professional crew arrives on schedule with premium materials, completing your roof replacement with expert craftsmanship.'
    },
    {
      number: '4',
      icon: 'ri-checkbox-circle-line',
      title: 'Final Inspection',
      description: 'Complete quality check and walkthrough, warranty activation, and our satisfaction guarantee ensures your peace of mind.'
    }
  ];

  return (
    <section id="process" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-[#1B2838] mb-4">
            Our Simple 4-Step Process
          </h2>
          <p className="text-gray-600 text-xl">
            From inspection to completion
          </p>
        </div>

        {/* Timeline */}
        <div className="relative mb-16">
          {/* Connecting Line */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-1 border-t-2 border-dashed border-[#1B2838]" style={{ marginLeft: '10%', marginRight: '10%' }}></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
            {steps.map((step, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                {/* Circle Node */}
                <div className="relative w-32 h-32 rounded-full bg-white border-4 border-[#1B2838] flex flex-col items-center justify-center mb-8 z-10">
                  <span className="text-[#FF6B35] text-5xl font-bold mb-1">{step.number}</span>
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${step.icon} text-[#1B2838] text-2xl`}></i>
                  </div>
                </div>

                {/* Content */}
                <div className="max-w-xs">
                  <h3 className="text-[#1B2838] text-2xl font-bold mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button 
            onClick={scrollToContact}
            className="inline-flex items-center gap-3 bg-[#FF6B35] text-white px-10 py-4 rounded-full hover:bg-[#ff5722] transition-all duration-300 text-lg font-semibold shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Start Your Free Inspection
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}